import React from "react";
import { useForm } from "react-hook-form";

const Agreement = (props) => {
	const { next, previous } = props;
	const { handleSubmit, register, errors } = useForm();
	return (
		<div className="container px-5 pt-5 custom-modal">
			<div className="row">
				<h2>Retailer Agreement</h2>
			</div>
			<div className="row">
				<h6 className='text-dark'>
					Before becoming an eksplode! Retailer, you must agree to the following
					terms and conditions set forth below. By using eksplode! Marketing you
					hereby acknowledge, understand, and agree –
				</h6>
			</div>
			<div className="row">
				<ul>
					<li>
						Not to hold eksplode! Marketing, its owners, parent companies, shareholders, affiliates, associates, employees, Members, Stars or staff liable, accountable, or responsible for any harm, loss, damage, injury, or action you or your company sustain as a result of using eksplode! Marketing and its services, systems, and platforms. 
					</li>
					<li>That eksplode! Marketing has the right to refuse its services, systems, and platforms to anyone, and, may cancel, withdraw, or remove such at any time. 
					</li>
					<li>
						That eksplode! Marketing owns the intellectual property/copyrights to each and every video submitted, uploaded, or posted on our platform. 
					</li>
					<li>
						That eksplode! Marketing extracts/deducts a fee of 5% from each and every individual transaction that it processes through its system from you and/or your company. 
					</li>
					<li>
						That eksplode! Marketing does not, cannot, and will not guarantee any sales of your (or your company's) products/services though its services, system, and platforms.  
					</li>
					<li>
						To post a notice on you or your company's eksplode! catalog notifying all customers of a surcharge/restocking fee for any returns or cancellation fees for products/services processed through eksplode!, of an amount equal to or greater than the amount posted as a Member/Promoter's reward, including eksplode!'s fee of 5%. For example, if 10% of the retail price for the product/service is posted as a reward, the Retailer will notify the customer that a surcharge or cancellation fee of 15% (10% + 5% = 15%) will be forfeited and nonrefundable. 
					</li>
					<li>
					That the failure by the Retailer to post a notification of a surcharge/restocking/cancellation fee will result in the removal by eksplode! Marketing of that Retailer's eksplode! catalog. (This policy is strictly enforced to prevent fraud).  
					</li>
					<li>
						That you or your company will not reproduce/copy/duplicate any videos and their contents shown on eksplode!'s vac platform without the written consent from eksplode! Marketing.  
					</li>
					<li>
						That you or your company will not be allowed to reduce the dollar amount offered as a reward to eksplode! Members until 24 hours after you or your company posts a notice of the reduction. 
					</li>
					<li>
						That eksplode! Marketing will not refund/return the prize money placed in its escrow account by you or your company if an eksplode! Star submits a video promoting the product/service listed by you or your company within 30 days of such placement. 
					</li>
					<li>
						 That you or your company will not sell anything or provide a service that is illegal under federal or state law, or in violator of any state or county ordinance
					</li>
					<li>
						That you or your company give full authorization to eksplode! Marketing to conduct financial transactions involving products/services listed by you or your company on its site on your or your company's behalf.
					</li>
					<li>
						That you or your company will not post or mention your own or your
						company's website/web address anywhere on eksplode!'s platform.
					</li>
					<li>
						That you or your company are responsible for notifying customers on
						your eksplode! page of any additional costs, such as sales taxes,
						shipping and handling fees, etc.
					</li>
					<li>
						That you or your company will not hold eksplode! Marketing
						accountable for any additional expenses that you or your company
						might or does incur from using our platform/services/system.
					</li>
					<li>
						That you or your company are solely responsible for issuing refunds
						for returns/cancellations for services time.
					</li>
					<li>
						That eksplode! Marketing can and will change, modify, amend, add, or
						remove its rules/requirements/notifications at any time
					</li>
					<li>
						That you or your company is required to have a PayPal account, or an
						account of a bank or other financial institution in order to become
						an eksplode! Retailer
					</li>
				</ul>
			</div>
			<div className="row d-flex flex-column">
				<div className="d-flex justify-content-start mt-3 align-items-center">
					<input
						type="checkbox"
						className="form-control w-auto mr-3"
						id="read"
						name="read"
						ref={register({
							required: {
								value: true,
								message: "Please accept the agreement to continue",
							},
						})}
					/>
					<p className="mb-0">I agree to the above mentioned terms</p>
				</div>
				<label htmlFor="read" className="error mt-2">
					{errors.read && errors.read.message}
				</label>
			</div>
			<div className="row mt-3 justify-content-center">
				<button
					className="btn btn-solid mx-1"
					style={{ minWidth: "150px" }}
					onClick={previous}
				>
					Previous
				</button>
				<button
					className="btn btn-solid mx-1"
					style={{ minWidth: "150px" }}
					onClick={handleSubmit(next)}
				>
					Next
				</button>
			</div>
		</div>
	);
};

export default Agreement;
